import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  getStringHashCode26igk1bx568vk as getStringHashCode,
  toString1pkumu07cwy4m as toString,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Companion_getInstance14tgug8r8maei as Companion_getInstance } from '../ExecutionContext.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Buffer3384y49aj0pxr as Buffer } from '../../../../../../okio-parent-okio/okio/Buffer.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isCharSequence1ju9jr1w86plq as isCharSequence } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { trim11nh7r46at6sx as trim } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  HttpMethod_Get_instance = new (HttpMethod())('Get', 0);
  HttpMethod_Post_instance = new (HttpMethod())('Post', 1);
}
var HttpMethod_Get_instance;
var HttpMethod_Post_instance;
var HttpMethodClass;
function HttpMethod() {
  if (HttpMethodClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'HttpMethod');
    HttpMethodClass = $;
  }
  return HttpMethodClass;
}
var HttpHeaderClass;
function HttpHeader() {
  if (HttpHeaderClass === VOID) {
    class $ {
      constructor(name, value) {
        this.name_1 = name;
        this.value_1 = value;
      }
      toString() {
        return 'HttpHeader(name=' + this.name_1 + ', value=' + this.value_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.name_1);
        result = imul(result, 31) + getStringHashCode(this.value_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof HttpHeader()))
          return false;
        if (!(this.name_1 === other.name_1))
          return false;
        if (!(this.value_1 === other.value_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'HttpHeader');
    HttpHeaderClass = $;
  }
  return HttpHeaderClass;
}
function _get_hasBody__xziwnf($this) {
  return !($this.bodySource_1 == null) || !($this.bodyString_1 == null);
}
var BuilderClass;
function Builder() {
  if (BuilderClass === VOID) {
    class $ {
      constructor(statusCode) {
        this.statusCode_1 = statusCode;
        this.bodySource_1 = null;
        this.bodyString_1 = null;
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.headers_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        this.executionContext_1 = Companion_getInstance().Empty_1;
      }
      body_ph6982_k$(bodySource) {
        // Inline function 'kotlin.apply' call
        // Inline function 'kotlin.check' call
        if (!!_get_hasBody__xziwnf(this)) {
          var message = 'body() can only be called once';
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
        }
        this.bodySource_1 = bodySource;
        return this;
      }
      addHeader_jobub6_k$(name, value) {
        // Inline function 'kotlin.apply' call
        var tmp0 = this.headers_1;
        // Inline function 'kotlin.collections.plusAssign' call
        var element = new (HttpHeader())(name, value);
        tmp0.add_utx5q5_k$(element);
        return this;
      }
      addHeaders_2d4x0x_k$(headers) {
        // Inline function 'kotlin.apply' call
        this.headers_1.addAll_h3ej1q_k$(headers);
        return this;
      }
      build_1k0s4u_k$() {
        return new (HttpResponse())(this.statusCode_1, this.headers_1, this.bodySource_1, this.bodyString_1, this.executionContext_1);
      }
    }
    initMetadataForClass($, 'Builder');
    BuilderClass = $;
  }
  return BuilderClass;
}
var HttpResponseClass;
function HttpResponse() {
  if (HttpResponseClass === VOID) {
    class $ {
      constructor(statusCode, headers, bodySource, bodyString, executionContext) {
        this.statusCode_1 = statusCode;
        this.headers_1 = headers;
        this.bodySource_1 = bodySource;
        this.bodyString_1 = bodyString;
        this.executionContext_1 = executionContext;
      }
      get_body_wojkyz_k$() {
        var tmp0_elvis_lhs = this.bodySource_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          var tmp1_safe_receiver = this.bodyString_1;
          var tmp_0;
          if (tmp1_safe_receiver == null) {
            tmp_0 = null;
          } else {
            // Inline function 'kotlin.let' call
            tmp_0 = (new (Buffer())()).write_nkn6vw_k$(tmp1_safe_receiver);
          }
          tmp = tmp_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'HttpResponse');
    HttpResponseClass = $;
  }
  return HttpResponseClass;
}
var BuilderClass_0;
function Builder_0() {
  if (BuilderClass_0 === VOID) {
    class $ {
      constructor(method, url) {
        this.method_1 = method;
        this.url_1 = url;
        this.body_1 = null;
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.headers_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        this.executionContext_1 = Companion_getInstance().Empty_1;
      }
      body_3hhs87_k$(body) {
        // Inline function 'kotlin.apply' call
        this.body_1 = body;
        return this;
      }
      addHeader_jobub6_k$(name, value) {
        // Inline function 'kotlin.apply' call
        var tmp0 = this.headers_1;
        // Inline function 'kotlin.collections.plusAssign' call
        var element = new (HttpHeader())(name, value);
        tmp0.add_utx5q5_k$(element);
        return this;
      }
      addHeaders_2d4x0x_k$(headers) {
        // Inline function 'kotlin.apply' call
        this.headers_1.addAll_h3ej1q_k$(headers);
        return this;
      }
      addExecutionContext_c49mf3_k$(executionContext) {
        // Inline function 'kotlin.apply' call
        this.executionContext_1 = this.executionContext_1.plus_kymzvj_k$(executionContext);
        return this;
      }
      build_1k0s4u_k$() {
        return new (HttpRequest())(this.method_1, this.url_1, this.headers_1, this.body_1, this.executionContext_1);
      }
    }
    initMetadataForClass($, 'Builder');
    BuilderClass_0 = $;
  }
  return BuilderClass_0;
}
var HttpRequestClass;
function HttpRequest() {
  if (HttpRequestClass === VOID) {
    class $ {
      constructor(method, url, headers, body, executionContext) {
        this.method_1 = method;
        this.url_1 = url;
        this.headers_1 = headers;
        this.body_1 = body;
        this.executionContext_1 = executionContext;
      }
      newBuilder_laelpq_k$(method, url) {
        // Inline function 'kotlin.apply' call
        var this_0 = new (Builder_0())(method, url);
        if (!(this.body_1 == null)) {
          this_0.body_3hhs87_k$(this.body_1);
        }
        this_0.addHeaders_2d4x0x_k$(this.headers_1);
        this_0.addExecutionContext_c49mf3_k$(this.executionContext_1);
        return this_0;
      }
      newBuilder$default_4j1svq_k$(method, url, $super) {
        method = method === VOID ? this.method_1 : method;
        url = url === VOID ? this.url_1 : url;
        return $super === VOID ? this.newBuilder_laelpq_k$(method, url) : $super.newBuilder_laelpq_k$.call(this, method, url);
      }
    }
    initMetadataForClass($, 'HttpRequest');
    HttpRequestClass = $;
  }
  return HttpRequestClass;
}
function get(_this__u8e3s4, name) {
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlin.collections.singleOrNull' call
    var single = null;
    var found = false;
    var _iterator__ex2g4s = _this__u8e3s4.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp = element.name_1.toLowerCase();
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      if (tmp === name.toLowerCase()) {
        if (found) {
          tmp$ret$0 = null;
          break $l$block_0;
        }
        single = element;
        found = true;
      }
    }
    if (!found) {
      tmp$ret$0 = null;
      break $l$block_0;
    }
    tmp$ret$0 = single;
  }
  var tmp0_safe_receiver = tmp$ret$0;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.value_1;
  var tmp_0;
  if (tmp1_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.text.trim' call
    tmp_0 = toString(trim(isCharSequence(tmp1_safe_receiver) ? tmp1_safe_receiver : THROW_CCE()));
  }
  return tmp_0;
}
function HttpMethod_Get_getInstance() {
  static_init();
  return HttpMethod_Get_instance;
}
function HttpMethod_Post_getInstance() {
  static_init();
  return HttpMethod_Post_instance;
}
//region block: exports
export {
  HttpHeader as HttpHeader1d7ldebjomr00,
  Builder_0 as Builder2ocxamygt14i4,
  Builder as Builder1mo34du82b3c6,
  get as get3c0ofj2dgi8ma,
  HttpMethod_Get_getInstance as HttpMethod_Get_getInstancek26a5f4rdtug,
  HttpMethod_Post_getInstance as HttpMethod_Post_getInstance3lyly75k5cb7q,
};
//endregion

//# sourceMappingURL=Http.mjs.map
